module.exports = __webpack_public_path__ + "static/img/qpmn_mobile_en.baf593a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/qpmn_mobile_en.jpg
// module id = REua
// module chunks = 47